module.exports = __webpack_public_path__ + "assets/img/10-s.020a8fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/10-s.jpg
// module id = +fdp
// module chunks = 0